import styled from 'styled-components';

export const ContainerStyled = styled.div`
    .btn-search{
        height: 36px;
        margin-top 25px;
        margin-left: 15px;
        padding-left: 20px;
        padding-right: 20px;

        .svg-inline--fa{
            margin-right: 8px;
        }
    }

    .btn-voltar-title{
        margin-top: 40px;
    }
    h2{
        margin-top: 0px;
    }
    .header-list{
        margin-top: 46px;
    }
    .list-group{
        margin-bottom: 42px;
    }
    .img-loader{
        margin: 0 auto;
        width: 80px;
    }
    .txt-resultado-busca{
        h3{
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            line-height: 40px;
            text-align: center;
            color: #475466;
            margin-bottom: 5px;
        }
        p{
            text-align: center;
            font-style: normal;
            font-weight: 300;
            font-size: 19px;
            line-height: 40px;
            text-align: center;
            color: #475466;
        }
        
    }
`;